document.addEventListener('DOMContentLoaded', function() {

  const BASE_PRICE_CENTS = window.PAGAR_CONFIG.basePriceCents;
  const VERCEL_URL = window.PAGAR_CONFIG.vercelUrl;
  const CONTACT_EMAIL = "almapampamendoza@gmail.com";
  const WA_NUMBER = "5492614724190";

  let finalCharge = BASE_PRICE_CENTS / 100;

  // Captura los variant_id + cantidad del carrito de Shopify (para crear la orden
  // en Shopify al confirmar el pago). El resumen de Chile se arma desde Liquid,
  // pero consultamos /cart.js solo para obtener los IDs reales de cada producto.
  let cartLineItems = [];
  function fetchCartLineItems() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart && cart.items) {
          cartLineItems = cart.items.map(function(i) {
            return { variant_id: i.variant_id, quantity: i.quantity };
          });
        }
      })
      .catch(function(e) { console.warn('No se pudieron leer los IDs del carrito:', e); });
  }
  fetchCartLineItems();

  // ─── META TRACKING (Conversions API) ─────────────────────────────
  // Captura las "huellas" del navegador (Momento 1, cliente presente).
  // Viajan al backend y se guardan en Sheets; se usan al confirmar el pago.
  (function persistFbclid() {
    var fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (fbclid) {
      var d = new Date();
      d.setTime(d.getTime() + 90 * 24 * 60 * 60 * 1000);
      document.cookie = '_ap_fbclid=' + encodeURIComponent(fbclid) +
        ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    }
  })();
  function apGetCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : '';
  }
  function apBuildFbc() {
    var fbc = apGetCookie('_fbc');
    if (fbc) return fbc;
    var fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (!fbclid) fbclid = apGetCookie('_ap_fbclid');
    if (fbclid) return 'fb.1.' + Date.now() + '.' + fbclid;
    return '';
  }
  function apGenEventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'ev-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }
  function apGetMetaTracking() {
    return { fbp: apGetCookie('_fbp'), fbc: apBuildFbc(), eventId: apGenEventId() };
  }

  const btnContinue  = document.getElementById('btn-continue');
  const btnBack      = document.getElementById('btn-back');
  const stepCustomer = document.getElementById('step-customer');
  const stepPayment  = document.getElementById('step-payment');
  const stepConfirm  = document.getElementById('step-confirm');

  function fmt(cents) {
    return 'ARS $ ' + Math.round(cents / 100).toLocaleString('es-AR', {
      minimumFractionDigits: 0, maximumFractionDigits: 0
    });
  }

  // Devuelve el monto en ARS efectivo (con descuento de país aplicado si
  // corresponde). Si el conversor todavía no cargó, devuelve el monto
  // sin descuento (fallback seguro: cobramos de más, no de menos).
  // El descuento se decide en currency-converter.liquid según país detectado.
  function getEffectiveArsCents() {
    if (window.AP_CURRENCY && typeof window.AP_CURRENCY.arsEffective === 'function') {
      return window.AP_CURRENCY.arsEffective(BASE_PRICE_CENTS);
    }
    return BASE_PRICE_CENTS;
  }

  // Actualizar totales — Fiserv siempre cobra en ARS, el resto en la moneda activa
  function updateTotals() {
    // ARS efectivo: lo que realmente cobramos al cliente (con -8% si país=CL)
    var effectiveCents = getEffectiveArsCents();

    // Fiserv: siempre en ARS, pero usando el ARS efectivo (con descuento)
    var fiservDisplay = document.getElementById('fiserv-total-display');
    if (fiservDisplay) fiservDisplay.textContent = fmt(effectiveCents);
    document.getElementById('chargetotal').value = (effectiveCents / 100).toFixed(2);
    finalCharge = effectiveCents / 100;

    var note = document.getElementById('fiserv-currency-note');
    if (note) {
      var activeCurrency = (window.AP_CURRENCY && window.AP_CURRENCY.current)
        ? window.AP_CURRENCY.current() : 'ARS';
      // Mostrar nota de conversión cuando la moneda activa NO es ARS
      note.style.display = activeCurrency !== 'ARS' ? 'block' : 'none';
    }

    // Refrescar el resumen del carrito (ítems + subtotal + total) en la moneda activa
    // Los elementos tienen data-ars-cents hardcodeados desde Liquid — el conversor los actualiza
    // (y aplica el descuento de país si corresponde).
    if (window.AP_CURRENCY && typeof window.AP_CURRENCY.refresh === 'function') {
      window.AP_CURRENCY.refresh();
    }
  }

  window.AP_PAGAR_CHILE_UPDATE = function() { updateTotals(); };
  updateTotals();

  // Esperar a que el conversor esté listo (carga asíncrona) y re-actualizar
  function waitForCurrencyAndUpdate() {
    if (window.AP_CURRENCY && typeof window.AP_CURRENCY.current === 'function') {
      updateTotals();
    } else {
      setTimeout(waitForCurrencyAndUpdate, 150);
    }
  }
  waitForCurrencyAndUpdate();

  // ─── VALIDACIONES ────────────────────────────────────────────────
  function validateEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function showFieldError(fieldId, message) {
    const el = document.getElementById('error-' + fieldId);
    const input = document.getElementById(fieldId);
    if (el) el.textContent = message;
    if (input) { input.classList.add('input-error'); input.classList.remove('input-ok'); }
  }

  function clearFieldError(fieldId) {
    const el = document.getElementById('error-' + fieldId);
    const input = document.getElementById(fieldId);
    if (el) el.textContent = '';
    if (input && input.value.trim() !== '') {
      input.classList.add('input-ok'); input.classList.remove('input-error');
    } else if (input) {
      input.classList.remove('input-ok'); input.classList.remove('input-error');
    }
  }

  document.getElementById('email').addEventListener('blur', function() {
    if (this.value && !validateEmail(this.value)) {
      showFieldError('email', 'Ingresá un email válido (ej: nombre@correo.com)');
    } else { clearFieldError('email'); }
  });

  document.getElementById('phone').addEventListener('input', function() {
    this.value = this.value.replace(/[^0-9\s]/g, '');
  });

  document.getElementById('phone').addEventListener('blur', function() {
    const digits = this.value.replace(/\s/g, '');
    if (digits.length < 8 || digits.length > 9) {
      showFieldError('phone', 'Ingresá un número chileno válido (9 dígitos)');
    } else { clearFieldError('phone'); }
  });

  document.getElementById('streetNumber').addEventListener('input', function() {
    this.value = this.value.replace(/[^0-9a-zA-Z\s\-\/]/g, '');
  });

  function checkFormValid() {
    const required = ['firstName', 'lastName', 'email', 'address', 'streetNumber', 'city', 'postalCode'];
    const allFilled = required.every(function(id) {
      const el = document.getElementById(id);
      return el && el.value.trim() !== '';
    });
    const phoneDigits = document.getElementById('phone').value.replace(/\s/g, '');
    const phoneOk = phoneDigits.length >= 8 && phoneDigits.length <= 9;
    const provinceOk = document.getElementById('province').value !== '';
    const emailOk = validateEmail(document.getElementById('email').value);
    btnContinue.disabled = !(allFilled && phoneOk && provinceOk && emailOk);
  }

  document.querySelectorAll('#step-customer input').forEach(function(input) {
    input.addEventListener('input', checkFormValid);
  });
  document.getElementById('province').addEventListener('change', checkFormValid);

  // ─── ENVIAR NOTIFICACIÓN AL SERVIDOR ────────────────────────────
  function sendNotification(paymentMethod, orderData) {
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://fiserv-redirect-server.vercel.app/send-notification', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(Object.assign({}, orderData, { paymentMethod })));
    } catch(e) {
      console.warn('No se pudo enviar notificación:', e);
    }
  }

  // ─── MOSTRAR PANTALLA DE CONFIRMACIÓN ───────────────────────────
  function showConfirmScreen(method, orderData) {
    var displayTotal = orderData.displayTotal;
    var currency     = orderData.currency;
    var firstName    = orderData.firstName;
    var email        = orderData.email;

    var html = '';

    if (method === 'transfer') {
      var waText = encodeURIComponent(
        '¡Hola Alma Pampa! Acabo de hacer una transferencia por mi pedido.\n\n' +
        'Nombre: ' + orderData.firstName + ' ' + orderData.lastName + '\n' +
        'Email: ' + orderData.email + '\n' +
        'Productos: ' + orderData.cartItems + '\n' +
        'Monto: ' + displayTotal + '\n' +
        'Adjunto el comprobante.'
      );
      var waUrl = 'https://wa.me/' + WA_NUMBER + '?text=' + waText;
      var gmailUrl = 'https://mail.google.com/mail/?view=cm' +
        '&to=' + encodeURIComponent(CONTACT_EMAIL) +
        '&su=' + encodeURIComponent('Comprobante transferencia - ' + firstName) +
        '&body=' + encodeURIComponent(
          'Hola Alma Pampa,\n\nAdjunto el comprobante de transferencia.\n\n' +
          'Nombre: ' + orderData.firstName + ' ' + orderData.lastName + '\n' +
          'Productos: ' + orderData.cartItems + '\n' +
          'Monto: ' + displayTotal
        );

      html =
        '<div class="confirm-icon">✅</div>' +
        '<h2 class="confirm-title">¡Pedido recibido!</h2>' +
        '<p class="confirm-subtitle">Ya tenemos tus datos. Para confirmar tu compra, realizá la transferencia y envianos el comprobante.</p>' +
        '<div class="confirm-bank-box">' +
          '<div class="confirm-bank-title">Datos para transferir</div>' +
          '<div class="confirm-bank-row"><span>Titular</span><span>ALMA PAMPA SPA</span></div>' +
          '<div class="confirm-bank-row"><span>RUT</span><span>77.557.836-K</span></div>' +
          '<div class="confirm-bank-row"><span>Banco</span><span>Mercado Pago</span></div>' +
          '<div class="confirm-bank-row"><span>Tipo de cuenta</span><span>Cuenta Vista</span></div>' +
          '<div class="confirm-bank-row"><span>Número</span><span>1021769354</span></div>' +
          '<div class="confirm-bank-row confirm-bank-total"><span>Monto a transferir</span><span>' + displayTotal + '</span></div>' +
        '</div>' +
        '<p class="confirm-note">Una vez transferido, envianos el comprobante por WhatsApp o email:</p>' +
        '<a href="' + waUrl + '" target="_blank" class="confirm-btn-wa">💬 Enviar comprobante por WhatsApp</a>' +
        '<a href="' + gmailUrl + '" target="_blank" class="confirm-btn-email">✉️ Enviar por email</a>' +
        '<p class="confirm-email-note">También te enviamos un resumen a <strong>' + email + '</strong></p>';

    } else if (method === 'mercadopago') {
      html =
        '<div class="confirm-icon">✅</div>' +
        '<h2 class="confirm-title">¡Pedido recibido!</h2>' +
        '<p class="confirm-subtitle">Recibimos tu solicitud de pago por MercadoPago.</p>' +
        '<div class="confirm-mp-box">' +
          '<div class="confirm-mp-amount">' + displayTotal + '</div>' +
          '<div class="confirm-mp-label">Monto de tu pedido</div>' +
        '</div>' +
        '<p class="confirm-note">En las próximas <strong>24 horas</strong> te enviamos el link de pago a:</p>' +
        '<div class="confirm-email-highlight">' + email + '</div>' +
        '<p class="confirm-email-note">Revisá también tu carpeta de spam por las dudas.</p>';
    }

    document.getElementById('confirm-content').innerHTML = html;
    stepPayment.style.display = 'none';
    stepConfirm.style.display = 'block';
    window.scrollTo(0, 0);
  }

  // ─── BOTÓN CONTINUAR ─────────────────────────────────────────────
  btnContinue.addEventListener('click', function() {
    const apt      = document.getElementById('apartment').value.trim();
    const street   = document.getElementById('address').value.trim();
    const number   = document.getElementById('streetNumber').value.trim();
    const notes    = document.getElementById('notes').value.trim();
    const email    = document.getElementById('email').value.trim();
    const firstName  = document.getElementById('firstName').value.trim();
    const lastName   = document.getElementById('lastName').value.trim();
    const city       = document.getElementById('city').value.trim();
    const province   = document.getElementById('province').value;
    const postalCode = document.getElementById('postalCode').value.trim();
    const phone = '+56 ' + document.getElementById('phone').value.trim();

    // ARS efectivo: lo que realmente le cobramos (con -8% si país=CL)
    // Es el monto que se manda al backend para que figure en el sheet.
    var effectiveCents = getEffectiveArsCents();
    const totalARS = (effectiveCents / 100).toFixed(0);

    document.getElementById('confirmed-summary').innerHTML =
      '<div class="pagar-confirmed-item"><strong>' + firstName + ' ' + lastName + '</strong></div>' +
      '<div class="pagar-confirmed-item">' + email + ' · ' + phone + '</div>' +
      '<div class="pagar-confirmed-item">' +
        street + ' ' + number + (apt ? ', ' + apt : '') + ', ' +
        city + ', ' + province + (postalCode ? ', CP ' + postalCode : '') + ', Chile' +
      '</div>' +
      (notes ? '<div class="pagar-confirmed-item">📝 ' + notes + '</div>' : '');

    // Capturar tipo de cambio del momento.
    // El conversor ya aplica el descuento de país, así que displayTotal
    // refleja el precio final que ve el cliente (en CLP o ARS).
    var currency     = window.AP_CURRENCY ? window.AP_CURRENCY.current() : 'CLP';
    var displayTotal = window.AP_CURRENCY ? window.AP_CURRENCY.convert(BASE_PRICE_CENTS / 100) : ('$ ' + totalARS);

    var metaTracking = apGetMetaTracking();

    // Guardar datos del pedido para usar en los botones de pago
    window._currentOrder = {
      firstName, lastName, email, phone,
      address: street + ' ' + number,
      apartment: apt,
      city, province, postalCode,
      country: 'CL',
      cartItems: window.PAGAR_CONFIG.cartItems,
      lineItems: cartLineItems,
      arsTotal: totalARS,           // ARS efectivo (con -8% si CL)
      currency: currency,
      displayTotal: displayTotal,
      notes,
      oid: 'AP-' + Date.now(),
      fbp: metaTracking.fbp,
      fbc: metaTracking.fbc,
      eventId: metaTracking.eventId,
    };

    stepCustomer.style.display = 'none';
    stepPayment.style.display = 'block';
    window.scrollTo(0, 0);
  });

  // ─── BOTÓN VOLVER ────────────────────────────────────────────────
  btnBack.addEventListener('click', function() {
    stepPayment.style.display = 'none';
    stepCustomer.style.display = 'block';
    window.scrollTo(0, 0);
    checkFormValid();
  });

  // ─── BOTÓN TRANSFERENCIA ─────────────────────────────────────────
  document.getElementById('transfer-btn').addEventListener('click', function() {
    var order = window._currentOrder;
    if (!order) return;
    sendNotification('transfer', order);
    showConfirmScreen('transfer', order);
  });

  // ─── BOTÓN MERCADO PAGO ──────────────────────────────────────────
  document.getElementById('mp-btn').addEventListener('click', function() {
    var order = window._currentOrder;
    if (!order) return;
    sendNotification('mercadopago', order);
    showConfirmScreen('mercadopago', order);
  });

  // ─── BOTÓN PAGAR CON TARJETA (FISERV) ───────────────────────────
  document.getElementById('fiserv-pay-button').addEventListener('click', async function() {
    const btn = this;
    btn.disabled = true;
    btn.innerHTML = 'Pagar con tarjeta';

    const oidValue   = 'AP-' + Date.now();
    const firstName  = document.getElementById('firstName').value.trim();
    const lastName   = document.getElementById('lastName').value.trim();
    const email      = document.getElementById('email').value.trim();
    const street     = document.getElementById('address').value.trim();
    const number     = document.getElementById('streetNumber').value.trim();
    const apt        = document.getElementById('apartment').value.trim();
    const city       = document.getElementById('city').value.trim();
    const province   = document.getElementById('province').value;
    const postalCode = document.getElementById('postalCode').value.trim();
    const notes      = document.getElementById('notes').value.trim();
    const phone      = '+56 ' + document.getElementById('phone').value.trim();
    var metaTracking = apGetMetaTracking();

    // ARS efectivo: lo que realmente cobra Fiserv (con -8% si país=CL)
    var effectiveCents = getEffectiveArsCents();

    const orderData = {
      firstName, lastName, email, phone,
      address:      street + ' ' + number,
      apartment:    apt,
      city, province, postalCode,
      country:      'CL',
      cartTotal:    (effectiveCents / 100).toFixed(2),   // ARS efectivo
      shippingCost: '0.00',
      finalTotal:   finalCharge.toFixed(2),              // = effectiveCents/100, ya seteado en updateTotals
      installments: 1,
      cartItems:    window.PAGAR_CONFIG.cartItems,
      oid:          oidValue,
      notes,
      lineItems:    cartLineItems,
      fbp:          metaTracking.fbp,
      fbc:          metaTracking.fbc,
      eventId:      metaTracking.eventId,
    };

    try {
      await fetch(VERCEL_URL + '/save-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orderData)
      });
    } catch(e) { console.error('Error guardando pedido:', e); }

    const now = new Date();
    const txndatetime =
      now.getFullYear() + ':' +
      String(now.getMonth() + 1).padStart(2, '0') + ':' +
      String(now.getDate()).padStart(2, '0') + '-' +
      String(now.getHours()).padStart(2, '0') + ':' +
      String(now.getMinutes()).padStart(2, '0') + ':' +
      String(now.getSeconds()).padStart(2, '0');

    document.getElementById('txndatetime').value = txndatetime;
    document.getElementById('oid-field').value = oidValue;

    const form     = document.getElementById('fiserv-form');
    const formData = new FormData(form);
    const params   = {};
    for (let [key, value] of formData.entries()) {
      if (key !== 'hashExtended') params[key] = value;
    }

    // El hash se calcula en el servidor — el secreto nunca está en el browser
    let hashResponse;
    try {
      hashResponse = await fetch(VERCEL_URL + '/generate-hash', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ params: params })
      });
    } catch(e) {
      console.error('Error generando hash:', e);
      btn.disabled = false;
      btn.innerHTML = 'Pagar con tarjeta';
      alert('Error al conectar con el servidor. Por favor intentá de nuevo.');
      return;
    }

    const hashData = await hashResponse.json();
    if (!hashData.hash) {
      btn.disabled = false;
      btn.innerHTML = 'Pagar con tarjeta';
      alert('Error al procesar el pago. Por favor intentá de nuevo.');
      return;
    }

    document.getElementById('hashExtended').value = hashData.hash;
    form.submit();
  });

});